import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::51cee2198a185514f1983d14f57a5d9a>>
 * @codegenCommand yarn workspace @atlaskit/link-analytics run codegen-analytics
 */

function createEventPayload(eventKey, attributes) {
  var _eventKey$split = eventKey.split('.'),
    _eventKey$split2 = _slicedToArray(_eventKey$split, 4),
    eventType = _eventKey$split2[0],
    actionSubject = _eventKey$split2[1],
    action = _eventKey$split2[2],
    actionSubjectId = _eventKey$split2[3];
  if (eventType === 'screen') {
    return {
      eventType: eventType,
      name: actionSubject,
      action: 'viewed',
      attributes: attributes
    };
  }
  return {
    eventType: eventType,
    actionSubject: actionSubject,
    actionSubjectId: actionSubjectId,
    action: action,
    attributes: attributes
  };
}
export default createEventPayload;